import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const getToken = () => localStorage.getItem("wff_token");
export const setToken = (t) => localStorage.setItem("wff_token", t);
export const clearToken = () => localStorage.removeItem("wff_token");
export const getEmail = () => localStorage.getItem("wff_email");
export const setEmail = (e) => localStorage.setItem("wff_email", e);

export const fetchMeta = () => api.get("/meta").then((r) => r.data);

export const fetchShows = (params = {}) => {
  const token = getToken();
  return api.get("/shows", { params: { ...params, token } }).then((r) => r.data);
};

export const fetchShow = (id) => {
  const token = getToken();
  return api.get(`/shows/${id}`, { params: { token } }).then((r) => r.data);
};

export const fetchFeatured = () => {
  const token = getToken();
  return api.get("/featured", { params: { token } }).then((r) => r.data);
};

export const requestOtp = (payload) => api.post("/otp/request", payload).then((r) => r.data);
export const verifyOtp = (email, code) => api.post("/otp/verify", { email, code }).then((r) => r.data);
export const fetchMe = () => api.get("/me", { params: { token: getToken() } }).then((r) => r.data);

export const startCheckout = () =>
  api
    .post("/payments/checkout", { origin_url: window.location.origin, token: getToken() })
    .then((r) => r.data);

export const paymentStatus = (sessionId) => api.get(`/payments/status/${sessionId}`).then((r) => r.data);

export const downloadCalendar = () =>
  api.post("/lead-magnet/calendar", { token: getToken() }, { responseType: "blob" }).then((r) => r.data);

export const fetchLeads = (passcode) =>
  api.get("/admin/leads", { headers: { "X-Admin-Token": passcode } }).then((r) => r.data);

export default api;
